import { render, staticRenderFns } from "./Agree2.vue?vue&type=template&id=a0b7b2b0&scoped=true"
import script from "./Agree2.vue?vue&type=script&lang=js"
export * from "./Agree2.vue?vue&type=script&lang=js"
import style0 from "./Agree2.vue?vue&type=style&index=0&id=a0b7b2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b7b2b0",
  null
  
)

export default component.exports